var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"image-container"},[_c('v-slide-group',{attrs:{"show-arrows":""}},_vm._l((_vm.file),function(item,index){return _c('v-slide-item',{key:index},[_c('g-img',{staticClass:"mr-1",staticStyle:{"cursor":"pointer"},attrs:{"file":item,"size":_vm.size}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }